export default {
  sidebar: {
    theme: '界面主题',
    language: '语言选择',
    pairing: '接收器配对',
    about: '关于软件',
    errorLog: '错误日志',
  },
  themes: {
    gleam: '幻光',
    scroll: '舒卷',
    pastel: '素彩',
    subtle: '隐光',
    stealth: '锋影',
    terminus: '末站',
    hackruin: '骇墟',
    moonview: '月舷',
    pink: '闪痕',
    mound: '莹丘',
    velvetIsle: '绒屿',
    cloudNook: '云坞',
    sunny: '晴笺',
    gentle: '柔台',
    refract: '折射',
    neonBlue: '霓澜',
  },
  languages: {
    zhCN: '中文',
    enUS: 'English',
  },
  theme: {
    customTitle: '自定义',
    presetTitle: '系统预设',
    custom: '自定义',
    upload: '上传壁纸',
    deleteTitle: '删除壁纸',
    deleteConfirm: '确定要删除该自定义壁纸吗？',
    onlySupportImage: '只支持 {types} 图片类型',
  },
  about: {
    contact: {
      title: '联系我们',
      description:
        '任何关于硬件产品、软件驱动的建议和问题，都可以联系我们；我们将持续优化，让 RAPOO 的用户体验更加人性化',
    },
    copyright: {
      title: '版权所有',
      description: '{year}年 RAPOO. 保留所有权利',
      openSourceLicense: '开源许可证',
    },
    notificationTitle: '消息提醒',
    run: {
      title: '运行设置',
      autoStartLabel: '开机自启动',
      silentBackgroundLabel: '自动静默后台',
      closeActionOptions: {
        minimize: '关闭时最小化',
        exit: '关闭时完全退出应用',
      },
    },
    update: {
      title: '软件更新',
      checkUpdatesButton: '检查更新',
      latestVersion: '已是最新',
      currentVersion: '当前版本V{version}',
      relaseNotes: '更新日志',
      checkUpdateDialog: {
        isLatestVersion: '当前已是最新版本',
        latestVersionText: '当前版本: V{version}',
        updatingText: '升级中请稍后，当前',
        updatingTipText: '升级过程中可能会重启设备，属于正常现象，不予理会即可',
        updateSuccess: '更新成功',
        UpdateError: '更新失败',
      },
      updateLogDialog: {
        title: '软件更新日志',
      },
    },
    errorLog: {
      title: '错误日志',
    },
  },
  device: {
    firmware: {
      title: '固件更新',
      dongleTitle: '接收器更新',
      checkUpdatesButton: '检查更新',
      currentVersion: '当前版本V{version}',
      latestVersion: '最新版本V{version}',
      releaseNotes: '更新日志',
      latestVersionTip: '当前固件已是最新版本',
      unsupportedOnlineUpdate: '当前固件不支持在线更新，可下载桌面 A HUB 驱动进行升级',
      upgradeWarning: '固件更新过程中，避免拔插设备或退出驱动程序。更新完成后，请重新连接设备',
      upgradeWiredTip: '固件升级需使用有线模式连接。',
      upgradeDongleWarning:
        '固件更新过程中，避免拔插设备或退出驱动程序。更新完成后，请重新连接设备',
      upgradingText: '升级中请稍后',
      upgradingTipText: '升级过程中可能会重启设备，属于正常现象，不予理会即可',
      upgradeLogTitle: '固件更新日志',
      upgradeLogEmpty: '当前还未有更新日志',
      downloadFailed: '固件下载失败，请检查网络后重试',
      hexNotFound: '升级包中未找到固件文件(.hex)',
      upgradingWarning: '已有固件升级任务进行中，请等待',
      upgradeFailed: '固件升级失败，请重试',
      boot: {
        defaultUpgraderName: 'Volt* Upgrader',
        confirmEnterBoot: {
          title: '准备进入固件升级模式',
          body1Prefix: '设备将进入升级模式，并可能显示为',
          body1Suffix: '。',
          body2: '请在随后弹出的设备选择窗口中，选择对应的升级设备并授权连接。',
          body3: '若未完成授权，键盘可能会停留在升级模式。此时重新插拔设备即可恢复。',
          confirm: '继续升级',
        },
        authorizeBootDevice: {
          title: '选择升级设备以继续',
          body1Prefix: '点击下方按钮，然后在系统窗口中选择：',
          body2: '请勿选择其他设备，否则无法继续升级。',
          body3: '若取消设备授权，键盘将停留在升级模式。请重新插拔键盘后再试。',
          confirm: '选择升级设备',
        },
        pickOwner: {
          title: '选择要恢复升级的产品',
          body1: '检测到升级模式设备，但无法自动判断对应型号（刷新后无先前连接记录）。',
          body2: '请选择实际正在升级的产品，以免下载错误固件包：',
        },
      },
    },
    productColor: {
      title: '产品颜色显示',
    },
    lowBattery: {
      title: '低电量显示',
      description: '当低电量时，鼠标灯效将会频繁闪烁进行提示',
    },
    wirelessSleepTime: {
      title: '无线休眠时间',
      description: '在指定时长内未操作{device}将进行休眠',
      tooltipContent:
        '竞技超核模式为高功率全速扫描模式，建议将等待时间设置在15分钟以内，以延长无线使用时长',
      disableSleepTooltip: '关闭后，{device}将不会自动进入休眠状态',
      shortTimeLabel: '2分钟',
      longTimeLabel: '120分钟',
      minuteUnit: '分钟',
    },
    usbReportRate: {
      title: 'USB 回报率',
    },
    frequencyBand: {
      title: '频段',
      description: '调整频段后，需将鼠标放回底座重新对码，方可生效',
    },
    brightness: {
      title: '屏显亮度',
    },
    factoryReset: {
      title: '恢复出厂设置',
      buttonText: '恢复出厂',
      description: '恢复设备默认设置，将删除该设备的所有个性化配置',
      dialogDescription: '将删除所有个性化设置，确认恢复出厂设置吗？',
      successMessage: '恢复出厂设置成功',
    },
  },
  pairing: {
    emptyText: '未检测到设备，请重试',
    selectTitle: '请选择接收器配对的产品设备型号',
    selectDescription:
      '1、请将要配对的产品使用有线模式与电脑连接；2、选择需要接收器配对的产品设备后，点击继续',
    connectDeviceBtn: '点击连接设备',
    addDeviceBtn: '新增配对设备',
    continueBtn: '继续(回车键)',
    multipleReceiverTip: '检测到当前有多个接收器，请只保留一个',
    step1: {
      title: '步骤一',
      content: '将接收器拔插在电脑上',
    },
    step2: {
      title: '步骤二',
      content: '先拨动电源开关到OFF，再断开有线连接，然后再拨到ON',
    },
    dialog: {
      instructionMouse: '同时按下鼠标【左、中、右】3键',
      instructionAutoPairing: '请保持鼠标和接收器与电脑连接，等待自动完成配对',
      instructionKeyboard: '确保键盘切到2.4G模式\n根据型号长按"{combinedKeys}"',
      success: '配对成功',
      fail: '配对失败',
      cancel: '取消',
      pairing: '配对中',
      retry: '重试',
      confirm: '确认',
    },
  },
}
